import { ChangeEvent, useCallback } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { UserFormData } from '../../add-user-dialog/user-form-page';

import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';

interface WorkPhoneTextFieldProps {
  watch: UseFormWatch<UserFormData>;
  setValue: UseFormSetValue<UserFormData>;
  disabled: boolean;
}

export default function WorkPhoneTextField({
  watch,
  setValue,
  disabled,
}: WorkPhoneTextFieldProps) {
  const phones = watch('phones');

  const handleWorkPhoneChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const workPhones = phones?.filter((phone) => phone.type === 'work') || [];
      const hasWorkPhones = workPhones.length > 0;

      if (hasWorkPhones) {
        if (e.target.value === '' && workPhones.length === 1) {
          setValue('phones', phones?.filter((phone) => phone.type !== 'work'), {
            shouldDirty: true,
          });
          return;
        } else {
          let foundWorkPhone = false;
          setValue(
            'phones',
            phones?.map((phone) => {
              if (phone.type === 'work' && !foundWorkPhone) {
                foundWorkPhone = true;
                return { ...phone, value: e.target.value };
              }
              return phone;
            }),
            { shouldDirty: true }
          );
        }
      } else {
        setValue(
          'phones',
          [
            ...(phones || []),
            {
              type: 'work',
              customType: '',
              value: e.target.value,
              primary: false,
            },
          ],
          { shouldDirty: true }
        );
      }
    },
    [phones, setValue]
  );

  return (
    <Tooltip
      arrow
      title={
        disabled
          ? `You need the "Edit Phone Numbers" permission to edit this field.`
          : ''
      }
    >
      <span>
        <TextField
          value={phones?.find((phone) => phone.type === 'work')?.value || ''}
          onChange={(e) => handleWorkPhoneChange(e)}
          autoComplete="off"
          label="Work Phone"
          sx={{ minWidth: 400 }}
          disabled={disabled}
        />
      </span>
    </Tooltip>
  );
}
